import React from 'react';
import Button from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';

export default function Financing() {
  return (
    <div className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <SafeIcon name="CreditCard" className="text-5xl text-primary mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Pricing & Financing</h1>
          <p className="text-xl text-slate-600">Major plumbing repairs shouldn't drain your savings. We offer flexible payment options.</p>
        </div>

        <div className="bg-slate-50 rounded-2xl p-8 md:p-12 border border-slate-200 mb-12">
          <h2 className="text-2xl font-bold mb-6 text-center">Our Upfront Pricing Guarantee</h2>
          <p className="text-lg text-slate-700 mb-6 text-center">
            We charge by the job, not by the hour. Before we start any work, you will receive a detailed, written breakdown of the cost. If the job takes longer than expected, you don't pay a penny more.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
             <div className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm">
                <SafeIcon name="CheckCircle" className="text-green-500 text-xl shrink-0" />
                <span className="font-medium">Free Estimates on Replacements</span>
             </div>
             <div className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm">
                <SafeIcon name="CheckCircle" className="text-green-500 text-xl shrink-0" />
                <span className="font-medium">No Hidden Travel Fees</span>
             </div>
             <div className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm">
                <SafeIcon name="CheckCircle" className="text-green-500 text-xl shrink-0" />
                <span className="font-medium">Parts & Labor Warranty</span>
             </div>
             <div className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm">
                <SafeIcon name="CheckCircle" className="text-green-500 text-xl shrink-0" />
                <span className="font-medium">Seniors Discount Available</span>
             </div>
          </div>
        </div>

        <div className="border-t border-slate-200 pt-12">
          <h2 className="text-3xl font-bold mb-8 text-center">Flexible Financing Options</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
            <div className="text-center p-6 border border-slate-200 rounded-xl">
              <div className="text-4xl font-bold text-primary mb-2">0%</div>
              <p className="font-semibold mb-2">Interest for 12 Months</p>
              <p className="text-sm text-slate-500">On approved credit for projects over $1,500.</p>
            </div>
            <div className="text-center p-6 border border-slate-200 rounded-xl">
              <div className="text-4xl font-bold text-primary mb-2">Low</div>
              <p className="font-semibold mb-2">Monthly Payments</p>
              <p className="text-sm text-slate-500">Terms up to 60 months available.</p>
            </div>
            <div className="text-center p-6 border border-slate-200 rounded-xl">
              <div className="text-4xl font-bold text-primary mb-2">Fast</div>
              <p className="font-semibold mb-2">Paperless Approval</p>
              <p className="text-sm text-slate-500">Get approved in minutes via smartphone.</p>
            </div>
          </div>
          <div className="text-center">
            <p className="text-slate-600 mb-6">We accept all major credit cards, Interac, and certified cheques.</p>
            <Button to="/contact" variant="primary">Contact Us for a Quote</Button>
          </div>
        </div>
      </div>
    </div>
  );
}